import type { LensVisits } from '~/pages/AskRichardUnified/lensVisits';

import type { Lens, LensSpace } from '~/types/leLens';

/**
 * The viewer's own teams, most recently visited first, then the team whose Lenses are read most.
 * A team is the viewer's when the API gives them a role in it or lists their email as a member.
 */
export function rankTeams(
  spaces: Array<LensSpace>,
  lenses: Array<Lens>,
  visits: LensVisits,
  viewerEmail?: string | null,
): Array<LensSpace> {
  const email = viewerEmail?.trim().toLowerCase();
  const isMine = (space: LensSpace) =>
    Boolean(space.role) || Boolean(email && space.members?.some((member) => member.email.toLowerCase() === email));
  const activity = (space: LensSpace) => {
    const inTeam = lenses.filter((lens) => lens.home?.kind === 'space' && lens.home.spaceId === space.id);
    return {
      lastVisit: Math.max(0, ...inTeam.map((lens) => Date.parse(visits[lens.id]?.seenAt ?? '') || 0)),
      readers: inTeam.reduce((sum, lens) => sum + (lens.readersThisWeek ?? 0), 0),
    };
  };
  return spaces
    .filter(isMine)
    .map((space) => ({ space, ...activity(space) }))
    .sort((left, right) => right.lastVisit - left.lastVisit || right.readers - left.readers)
    .map(({ space }) => space);
}
